import React, { Fragment } from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { isEmpty } from 'lodash';
import { Text } from 'Components/frameworks/text/Text';
import { Title } from 'Components/frameworks/title/Title';
export type StopProps = {
  arrivalTime?: string;
  day: string;
  departureTime?: string;
  description?: string;
  title: string;
};
export type ProgramProps = {
  className?: string;
  stops?: Array<StopProps>;
  subtitle?: string;
  title?: string;
};
export type ProductProgramProps = {
  extension?: ProgramProps;
  isDetailed: boolean;
  program: ProgramProps;
};

function ProductProgramSectionTitles({ className, subtitle, title }) {
  return (
    <div className={className}>
      <Title hLevel={2} theme="title-brand-n2">
        {title}
      </Title>
      <Title hLevel={3} theme="title-sans-n2">
        {subtitle}
      </Title>
    </div>
  );
}

function ProductProgramFull({ className, title, subtitle, stops }: ProgramProps) {
  return isEmpty(stops) ? null : (
    <Fragment>
      <ProductProgramSectionTitles
        className={classnames('mb-30', className)}
        subtitle={subtitle}
        title={title}
      />
      <div className="grid grid-cols-1 gap-20 sm:grid-cols-2">
        {stops.map(({ day, description, title: stopTitle, departureTime, arrivalTime }) => {
          const departureArrivalTime = [arrivalTime, departureTime].filter(Boolean).join('\n');
          return day || description || stopTitle ? (
            <div key={`${day} - ${departureTime} - ${arrivalTime}`}>
              <Title className="mb-5" hLevel={3} theme="title-sans-n3">
                {`${day} - ${stopTitle}`}
              </Title>
              <Text text={description} />
              {!!departureArrivalTime && <Text text={departureArrivalTime} />}
            </div>
          ) : null;
        })}
      </div>
    </Fragment>
  );
}

function ProductProgramLite({ className, title, subtitle, stops }: ProgramProps) {
  return isEmpty(stops) ? null : (
    <section className={classnames('flex flex-col gap-20 sm:flex-row', className)}>
      <ProductProgramSectionTitles className="w-full sm:w-1/2" subtitle={subtitle} title={title} />
      <div className="w-full sm:w-1/2">
        <ul className="text-14 leading-normal text-black">
          {stops.map(({ day, title: stopTitle }) => {
            return day || stopTitle ? (
              <li className="list-disc py-5" key={day}>
                <strong>{day}</strong> - {stopTitle}
              </li>
            ) : null;
          })}
        </ul>
      </div>
    </section>
  );
}

export function ProductProgram(props: ProductProgramProps) {
  const { extension = {}, isDetailed, program = {} } = props;

  if (isEmpty(program.stops)) {
    return null;
  }

  return isDetailed ? (
    <Fragment>
      <ProductProgramFull stops={program.stops} subtitle={program.subtitle} title={program.title} />
      <ProductProgramFull
        className="mt-40"
        stops={extension.stops}
        subtitle={extension.subtitle}
        title={extension.title}
      />
    </Fragment>
  ) : (
    <Fragment>
      <ProductProgramLite stops={program.stops} subtitle={program.subtitle} title={program.title} />
      <ProductProgramLite
        className="mt-40"
        stops={extension.stops}
        subtitle={extension.subtitle}
        title={extension.title}
      />
    </Fragment>
  );
}
